import React, { useMemo } from 'react'
import styled from 'styled-components';
import SizeCard from './SizeCard'
import SizeSystemCard from './SizeSystemCard';
import { cloneDeep } from 'lodash';

const StyledSizes = styled.div`
  list-style: none;
  opacity: 0.8;
`

const SizeSystem = ({ sizeSystem, sizeSystemIndex, open, setOpenSizeSystems, hideSizeSystemInfo }) => {
  const sizeSystemId = useMemo(() => sizeSystem.id, [sizeSystem])
  function handleOpen() {
    setOpenSizeSystems(prev => {
      prev[sizeSystemId] = prev[sizeSystemId] ? false : true
      return cloneDeep(prev)
    })
  }
  return (
    <>
      {!hideSizeSystemInfo && <SizeSystemCard
        sizeSystem={sizeSystem}
        open={open}
        handleOpen={handleOpen}
      />}
      {open &&
        <StyledSizes>
          {
            sizeSystem.sizes.map((size, sizeIndex) => {
              return (
                <SizeCard
                  key={size.id}
                  size={size}
                  sizeSystemId={sizeSystemId}
                  sizeSystemIndex={sizeSystemIndex}
                  sizeIndex={sizeIndex}
                />
              )
            })
          }
        </StyledSizes>
      }
    </>
  )
}

export default SizeSystem